// eslint-disable-next-line filenames/match-regex
import type { FC } from 'react';
import React from 'react';

import { CommonPhoneInput } from './components/common-phone-input';
import { validatePhone } from './helpers';
import type { IX5BankPhoneInputProps } from './models';

export const X5BankPhoneInput: FC<IX5BankPhoneInputProps> = ({ ...props }) => {
    return <CommonPhoneInput {...props} validatePhone={validatePhone} />;
};
